// Service worker registration with strict guards so it NEVER runs inside the
// Lovable editor preview, an iframe, or dev — only on the real published site.
// A stray service worker in preview keeps serving stale HTML and deleted chunks.
export function registerPwa() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  const host = window.location.hostname;
  const inIframe = window.self !== window.top;
  const isPreviewHost =
    host.startsWith("id-preview--") ||
    host.startsWith("preview--") ||
    host === "lovableproject.com" ||
    host.endsWith(".lovableproject.com") ||
    host === "lovableproject-dev.com" ||
    host.endsWith(".lovableproject-dev.com") ||
    host === "beta.lovable.dev" ||
    host.endsWith(".beta.lovable.dev");
  const swOff = new URL(window.location.href).searchParams.get("sw") === "off";

  const refuse = !import.meta.env.PROD || inIframe || isPreviewHost || swOff;

  if (refuse) {
    // Clean up any previously registered app service worker in these contexts.
    navigator.serviceWorker
      .getRegistrations?.()
      .then((regs) => {
        regs.forEach((r) => {
          if (r.active?.scriptURL?.endsWith("/sw.js")) r.unregister();
        });
      })
      .catch(() => {});
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
